module.exports = __webpack_public_path__ + "img/Digte_Forste-bilde-under-Inspirasjon-utenfra-–-dekadansedikterne.a7a467aa.jpg";